var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03109 1.53033C9.32398 1.23744 9.32398 0.762563 9.03109 0.46967C8.73819 0.176777 8.26332 0.176777 7.97042 0.46967L4.96511 3.47498L1.96002 0.469891C1.66712 0.176998 1.19225 0.176997 0.899358 0.469891C0.606464 0.762784 0.606465 1.23766 0.899358 1.53055L3.90445 4.53564L0.899357 7.54074C0.606464 7.83363 0.606464 8.3085 0.899357 8.6014C1.19225 8.89429 1.66712 8.89429 1.96002 8.6014L4.96511 5.5963L7.97042 8.60162C8.26332 8.89451 8.73819 8.89451 9.03109 8.60162C9.32398 8.30873 9.32398 7.83385 9.03109 7.54096L6.02577 4.53564L9.03109 1.53033Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.249d17962809e754ac5f9a8db080c658.svg";
export { ForwardRef as ReactComponent };